module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("After the Applause ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("Back from the war")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The non-war ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But I’m still a veteran ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("You look down to the floor")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("I served my country ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("My sacrifice was given ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Which you didn’t acknowledge")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And you’re not forgiven ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The world looks strange ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Through the same eyes ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("So many finals ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("So many silent goodbyes")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("There’s no more rainbows ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Amongst the blue skies ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("There’s no more shown gratitude ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Seems everyone has reached their prize ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("But everything changed for me")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("In such a short time ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But not to be seen ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Is the largest of crimes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1460047a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398433502_EPUB5.vue
// module id = 72
// module chunks = 0